import React, { Component,useState } from "react";
import { PhotoIcon, UserCircleIcon } from '@heroicons/react/24/solid'
import { useNavigate } from "react-router-dom";
import store from "@/redux/store";

import * as CustomerConst from "actions/customerConst";
import {FieldHolder} from "@/components/holders/FieldHolder";
import {Address} from "@/views/base/address/Address";
import  {ICustomer} from "@/models/Customer";

import { Vat } from "@/views/base/company/Vat";
import { Contact } from "../contact/Contact";
import { Bank } from "../Bank/Bank";


export function Edit({...props}) {
    const [selectedTab, setSelectedTab] = useState(1);
    
    
    
        
  const onSaveWrapped = (event) => {
    event.preventDefault();
    event.stopPropagation();
    
    const data = new FormData(event.target);
    const value = Object.fromEntries(data.entries());


props.onSaveHandler(value);
return false;
    store.dispatch({
      type: "t",
      data: value,
    });

      
    return false;
  };

function selectCustomerTab(event, tabId) {
    setSelectedTab(tabId);
}

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const tabs = [
  {id:1, name: 'Algemene gegevens', href: '#', current: true },
  {id:2, name: 'KvK & BTW', href: '#', current: false },
  {id:3, name: 'Bankgegevens', href: '#', current: false },
//  {id:4, name: 'Overige', href: '#', current: false },
]



let index = 0;
let registerKey = props.registerkey;
let register = props.register
let fieldData = props.data.company;
  return (
    <>



           


                <div className="grid grid-cols-12 gap-1">
                    <div className="col-span-12 sm:col-span-12">
                    <div className="grid grid-cols-12 gap-2">
            <FieldHolder colspan="10" smcolspan="5" label="Bedrijfsnaam" id={registerKey+"name"} error={props?.state?.error} className="col-span-8">                
                  <input
                    id="name"
                    type="text"
                    {...register(registerKey+"name")}
                    key={(fieldData && fieldData["name"]) ?? null}
                    
                    data-dashlane-disabled-on-field="true"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>
            <div className="col-span-4 flex" >
                      <div>
                        <button
                          type="button"
                          className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                          Logo
                        </button>
                        <p className="mt-2 text-xs leading-5 text-gray-400">JPG, GIF or PNG. 1MB max.</p>
                      </div>
                      <img
                        alt=""
                        src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                        className="h-24 w-24 flex-none rounded-lg bg-gray-800 object-cover"
                      />
                      </div>
</div>
            
                  </div>
                  <div className="col-span-12 sm:col-span-12">
                  
                  <div className="pt-5 ">
   <div>
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
        <select
          id="tabs"
          name="tabs"
          defaultValue={tabs.find((tab) => tab.id == selectedTab).name}
          className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
        >
          {tabs.map((tab) => (
            <option key={tab.name}>{tab.name}</option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
          <nav aria-label="Tabs" className="-mb-px flex space-x-8">
            {tabs.map((tab) => (
              <a
                key={tab.name}
                href="#"
                aria-current={tab.current ? 'page' : undefined}
                className={classNames(
                  tab.id == selectedTab
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:border-gray-200 hover:text-gray-700',
                  'flex whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium',
                )}
                onClick={(event) => selectCustomerTab(event, tab.id)}
              >
                {tab.name}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </div>
                  
                  </div>
                  
                  {selectedTab == 1 && fieldData && fieldData._addresses && fieldData._addresses.length > 0 && 
                  <>
                    <Address key={registerKey+`addresses.${index}.zipcode`} registerkey={registerKey+`addresses.${index}.`} data={fieldData.addresses[index]} index={index} state={props.state} register={register} />
                    <Contact key={registerKey+`contact.${index}.phone`} registerkey={registerKey+`contact.${index}.`} data={fieldData.contact[index]} index={index} state={props.state} register={register} />
                    </>
                    }
                  {selectedTab == 2 &&  
                    <Vat key={"vatPanel"} registerkey={registerKey} data={fieldData} state={props.state} register={register} />
                    }
                  {selectedTab == 3 &&  
                    <Bank key={"bankPanel"} registerkey={registerKey} data={fieldData} state={props.state} register={register} />
                    }
                    
                </div>
              </div>
              
    </>
      );
}      